import axios from "./axiosService";
import services from "./base";
import { DateTimeFormat } from "./common";


const documentService = {
  getDocumentbyExpedienteId: async (id) => {
    try {
      const response = await axios.get(services.urlDocument + "/expediente/" + id, { params: { id } });
      return response.data.map((item) => ({
        ...item,
        created_date: DateTimeFormat(item.created_date),
        updated_date: DateTimeFormat(item.updated_date),
      }));
    } catch (error) {
      return { error: true, message: error.message };
    }
  },

  getDocumentbyId: async (id) => {
    try {
      const response = await axios.get(`${services.urlDocument}/${id}`);
      return response.data;
    } catch (error) {
      return { error: true, message: error.message };
    }
  },

  createDocument: async (expedienteId, templateId) => {
    try {
      const response = await axios.post(`${services.urlDocument}/${expedienteId}/create-document/${templateId}`);
      if (response.data.error) {
        return response.data.error;
      } else {
        return response.status;
      }
    } catch (error) {
      console.log(error);
      return { error: true, message: error.message };
    }
  },

  updateDocumentById: async (obj) => {
    try {
      const response = await axios.patch(`${services.urlDocument}/${obj.id}`, obj);
      return response.data;
    } catch (error) {
      return { error: true, message: error.message };
    }
  },

  updateDocumentNameById: async (obj) => {
    try {
      const response = await axios.patch(`${services.urlDocument}/name/${obj.id}`, obj);
      return response.data;
    } catch (error) {
      return { error: true, message: error.message };
    }
  },

  deleteDocumentById: async (id) => {
    try {
      const response = await axios.delete(services.urlDocument + "/" + id, { params: { id } });
      return response.data;
    } catch (error) {
      return { error: true, message: error.message };
    }
  },
};

export default documentService;
